{
  "version": 1,
  "asset_id": "0bfa2be6-1cb8-424d-9b8d-461b3d101fa6",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0bfa2be6-1cb8-424d-9b8d-461b3d101fa6/sleeve-fitzer-3-220.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0bfa2be6-1cb8-424d-9b8d-461b3d101fa6/sleeve-fitzer-3-220.jpg",
  "original_filename": "sleeve-fitzer-3-220.jpg",
  "size": 7541,
  "content_type": "image/jpeg",
  "created_at": "2026-09-29T01:15:38Z"
}
